import { io, Socket } from 'socket.io-client';
import { Message } from '../types';

class SocketService {
  private socket: Socket | null = null;
  private userId: string | null = null;

  connect(token: string, userId: string, customServerUrl?: string) {
    if (this.socket) {
      if (!this.socket.connected) {
        this.socket.connect();
      }
      // Guarantee we emit join simply in case we missed it, it's harmless
      this.socket.emit('join', userId);
      return this.socket;
    }

    const defaultUrl = process.env.REACT_APP_BACKEND_URL || 'http://207.154.195.11:5000';
    const SOCKET_URL = customServerUrl || defaultUrl;
    
    this.socket = io(SOCKET_URL, {
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      auth: { token }
    });

    this.socket.on("connect_error", (err) => {
      console.log(`[MOBILE-LOG] [WebRTC] Global Socket connect_error: ${err.message}`);
    });

    this.userId = userId;

    this.socket.emit('join', userId);

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  sendMessage(messageData: { receiver: string; content: string; sender: string }) {
    if (this.socket) {
      this.socket.emit('sendMessage', messageData);
    }
  }

  onNewMessage(callback: (message: Message) => void) {
    if (this.socket) {
      this.socket.on('newMessage', callback);
    }
  }

  onNewNotification(callback: (notification: any) => void) {
    if (this.socket) {
      this.socket.on('newNotification', callback);
    }
  }

  onMessageSent(callback: (message: Message) => void) {
    if (this.socket) {
      this.socket.on('messageSent', callback);
    }
  }

  onStreamStarted(callback: (data: { streamer: string; title: string; streamKey: string }) => void) {
    if (this.socket) {
      this.socket.on('streamStarted', callback);
    }
  }

  onStreamStopped(callback: (data: { streamer: string }) => void) {
    if (this.socket) {
      this.socket.on('streamStopped', callback);
    }
  }

  removeListener(event: string, callback?: (...args: any[]) => void) {
    if (this.socket) {
      if (callback) {
        this.socket.off(event, callback);
      } else {
        this.socket.off(event);
      }
    }
  }

  getSocket() {
    return this.socket;
  }
}

export const socketService = new SocketService();
export default socketService;
